export default {
  // 基础服务地址（接口/静态资源等）
  // baseURL: 'http://localhost:8080', // 开发时用本地
  baseURL: '/', // 生产环境用公网IP
  // WebSocketURL: 'http://localhost:8080',
  WebSocketURL: 'https://api.sycaon.com', // 生产环境用正式域名
}